"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.pick.title': '员工入职',
    'onboarding.pick.description': '您想在公司中分配新职责给谁？',
    'onboarding.pick.loading': '加载职业中...',
};
